import type { NotificationEntity } from "../../model";

import { SLASH } from "~/shared/str";

const BASE_URL = "notifications";

const URLS = {
  markAsRead: (notificationId: NotificationEntity.Schema["id"]) =>
    [BASE_URL, notificationId, "mark-as-read"].join(SLASH),
  markAllAsRead: [BASE_URL, "mark-all-read"].join(SLASH),
  getMany: BASE_URL,
  getPaginated: [BASE_URL, "getPage"].join(SLASH),
};

export { URLS };
